module.exports = __webpack_public_path__ + "static/media/rightArrow.bceafbc2.svg";